import { Config } from '../core/config'

const getSegmento = (propension) => {
  let segmento;
  let segmentoAux;
  let value;
  for (segmento in Config.Segmento) {
    segmento = Config.Segmento[segmento];
    for (value in segmento.values) {
      if (segmento.values[value] == propension && segmento.enabled) {
        segmentoAux = segmento.name;
      }
    }
  }

  if (!segmentoAux) {
    segmentoAux = Config.SegmentoDefault;
  }
  return segmentoAux;
}

export default { getSegmento }


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/models/segmentado.js